import { render } from "./SummaryPlaceholders.vue?vue&type=template&id=6769faf8&scoped=true"
import script from "./SummaryPlaceholders.vue?vue&type=script&lang=js"
export * from "./SummaryPlaceholders.vue?vue&type=script&lang=js"

import "./SummaryPlaceholders.vue?vue&type=style&index=0&id=6769faf8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6769faf8"]])

export default __exports__